<template>
    <div v-if="isAnyFieldOfInvoiceRecipientFillable">
        <h2>
            {{
                eventData.chargeable ? $t('eventRegistration.payment.invoiceRecipient') :
                $t('eventRegistration.payment.contactPerson')
            }}
        </h2>
        <div v-if="!invoiceReceivingPerson">
            <h4>
                {{
                    eventData.chargeable ? $t('eventRegistration.payment.chooseInvoiceRecipient') :
                    $t('eventRegistration.payment.chooseContactPerson')
                }}
            </h4>
            <ParticipantsListing
                :select-mode="true"
                filter-by-age
                :select-mode-add-label="eventData.chargeable ? $t('eventRegistration.payment.createInvoiceRecipient') : $t('eventRegistration.payment.createContactPerson')"
                :select-mode-add-alternative-label="eventData.chargeable ? $t('eventRegistration.payment.differentInvoiceRecipient') : $t('eventRegistration.payment.differentContactPerson')"
                @selected-person="usePerson($event)"
                @add="usePerson()" />

            <base-input
                v-if="isAnyFieldOfInvoiceRecipientRequired"
                v-model="invoiceReceivingPerson"
                no-margin
                :rules="{invoiceRecipient: eventData.chargeable, contactPerson: !eventData.chargeable}">
                <input class="d-none">
            </base-input>
        </div>
        <div v-else>
            <PersonCard
                :id="'invoiceRecipient-' + invoiceReceivingPerson"
                :person-key="invoiceReceivingPerson"
                mount-opened-if-not-valid
                hide-delete
                registering-person-type="invoiceRecipient" />
        </div>
    </div>
</template>

<script>
import ParticipantsListing from "@/components/pages/registration/ParticipantsListing"
import registrationOnlineRegistrationFieldsMixin from "@/mixins/registration/registrationOnlineRegistrationFieldsMixin";
import PersonCard from "@/components/pages/registration/persons/PersonCard";
import diverseSalutationKey from "@/util/consts/diverseSalutationKey";

export default {
    name: "InvoiceRecipient",
    components: {PersonCard, ParticipantsListing},
    mixins: [registrationOnlineRegistrationFieldsMixin],
    data() {
        return {
            diverseSalutationKey: diverseSalutationKey.DIVERSE_SALUTATION_KEY,
            noneSalutationKey: diverseSalutationKey.NONE_SALUTATION_KEY
        }
    },
    computed: {
        persons: {
            get: function () {
                return this.registrationData.persons
            },
            set: function (value) {
                this.setRegistrationProp('persons', value)
            }
        },
        invoiceReceivingPerson: {
            get: function () {
                return this.registrationData.invoiceReceivingPerson
            },
            set: function (value) {
                this.setRegistrationProp('invoiceReceivingPerson', value)
            }
        },
        isAnyFieldOfInvoiceRecipientRequired() {
            return this.$store.getters['registration/isAnyFieldOfInvoiceRecipientRequired']
        },
        isAnyFieldOfInvoiceRecipientFillable() {
            return this.$store.getters['registration/isAnyFieldOfInvoiceRecipientFillable']
        }
    },
    methods: {
        usePerson(personKey) {
            const invoiceReceivingPerson = "invoiceRecipient"
            const persons = this.$cloneDeep(this.persons)
            let newInvoiceReceivingPersonObject = {}
            if (personKey) {
                newInvoiceReceivingPersonObject = this.$cloneDeep(persons[personKey])
                //Automatically assign type Person
                newInvoiceReceivingPersonObject.type = 1
                if (this.invoiceRecipientTypeRestriction !== null) newInvoiceReceivingPersonObject.type = this.invoiceRecipientTypeRestriction
                delete newInvoiceReceivingPersonObject.photosAllowed
                delete newInvoiceReceivingPersonObject.listOfParticipantsAllowed
                if (!this.getOrfValue("salutation", "invoiceRecipient")) {
                    delete newInvoiceReceivingPersonObject.salutation
                }
                if (!this.getOrfValue("phone", "invoiceRecipient")) {
                    delete newInvoiceReceivingPersonObject.phone
                }
                if (!this.getOrfValue("mail", "invoiceRecipient")) {
                    delete newInvoiceReceivingPersonObject.email
                }
                if (!this.getOrfValue("address", "invoiceRecipient")) {
                    delete newInvoiceReceivingPersonObject.additional1
                    delete newInvoiceReceivingPersonObject.addressType
                    delete newInvoiceReceivingPersonObject.cityId
                    delete newInvoiceReceivingPersonObject.cityValue
                    delete newInvoiceReceivingPersonObject.communityIdentificationNumber
                    delete newInvoiceReceivingPersonObject.countryId
                    delete newInvoiceReceivingPersonObject.houseNumber
                    delete newInvoiceReceivingPersonObject.isPostbox
                    delete newInvoiceReceivingPersonObject.postboxNumber
                    delete newInvoiceReceivingPersonObject.streetId
                    delete newInvoiceReceivingPersonObject.streetValue
                    delete newInvoiceReceivingPersonObject.zipId
                    delete newInvoiceReceivingPersonObject.zipValue
                }

                // if new person is organisation and old address was organisation address, change name and toTheAttention
                if (newInvoiceReceivingPersonObject.type === 2 && newInvoiceReceivingPersonObject.toTheAttention) {
                    const oldToTheAttention = newInvoiceReceivingPersonObject.toTheAttention
                    newInvoiceReceivingPersonObject.toTheAttention = newInvoiceReceivingPersonObject.firstname + ' ' + newInvoiceReceivingPersonObject.lastname
                    newInvoiceReceivingPersonObject.firstname = null
                    newInvoiceReceivingPersonObject.lastname = oldToTheAttention
                }


            }
            persons[invoiceReceivingPerson] = newInvoiceReceivingPersonObject
            this.persons = persons
            this.$nextTick(() => {
                this.invoiceReceivingPerson = invoiceReceivingPerson
            })
        }

    }
}
</script>

<style lang="scss" scoped>
:deep(.participant-card-wrapper) {
    max-width: 400px;

    &.active {
        max-width: none;
    }
}

</style>
